import { useEffect, useRef, useState } from 'react'

import styles from './Formtoggle.module.css'

export type FormtoggleProps = {
  name: string
  label: string
  option1label: string
  option1value: string
  option2label: string
  option2value: string
  isRequired?: boolean
  showRequired?: boolean
  defaultvalue?: string
}

export const PhnxFormtoggle: React.FC<FormtoggleProps> = ({
  name,
  label,
  option1label,
  option2label,
  option1value,
  option2value,
  isRequired,
  showRequired,
  defaultvalue,
}) => {
  const [activeButton, setActiveButton] = useState<number | null>(0)
  const [hiddenFieldValue, setHiddenFieldValue] = useState<string>('')

  const button1Ref = useRef<HTMLButtonElement>(null)
  const button2Ref = useRef<HTMLButtonElement>(null)

  const handleButtonClick = (index: number, value: string) => {
    setActiveButton(index === activeButton ? null : index)
    setHiddenFieldValue(index === activeButton ? '' : value)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (activeButton !== null) {
      if (event.key === 'ArrowLeft' && hiddenFieldValue !== option1value) {
        handleButtonClick(0, option1value)
        button1Ref.current?.focus()
      } else if (event.key === 'ArrowRight' && hiddenFieldValue !== option2value) {
        handleButtonClick(1, option2value)
        button2Ref.current?.focus()
      }
    }
  }

  useEffect(() => {
    if (defaultvalue === option1value) {
      setActiveButton(0)
      setHiddenFieldValue(option1value)
    }
    if (defaultvalue === option2value) {
      setActiveButton(1)
      setHiddenFieldValue(option2value)
    }
  }, [defaultvalue, option1value, option2value])

  return (
    <div className={styles['formtoggle']}>
      <label htmlFor={name}>
        {label && label} {isRequired && showRequired && '*'}
      </label>

      <div className={styles['toggle-group']}>
        <button
          tabIndex={activeButton === 0 ? 0 : -1}
          value={option1value}
          type="button"
          ref={button1Ref}
          className={`${styles['button-left']} ${styles[activeButton === 0 ? 'active' : 'inactive']}`}
          onClick={() => handleButtonClick(0, option1value)}
          onKeyDown={handleKeyDown}
        >
          {option1label}
        </button>
        <button
          tabIndex={activeButton === 1 ? 0 : -1}
          type="button"
          value={option2value}
          ref={button2Ref}
          className={`${styles['button-right']} ${styles[activeButton === 1 ? 'active' : 'inactive']}`}
          onClick={() => handleButtonClick(1, option2value)}
          onKeyDown={handleKeyDown}
        >
          {option2label}
        </button>
        <input
          type="hidden"
          name={name}
          value={hiddenFieldValue}
          required={isRequired}
          className={styles.hiddenFormElement}
        />
      </div>
    </div>
  )
}
